import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spoccenter-dashboard',
  templateUrl: './spoccenter-dashboard.component.html',
  styleUrls: ['./spoccenter-dashboard.component.scss']
})
export class SPOCCenterDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
